// extracted by mini-css-extract-plugin
export default {"logo":"DUut"};